import React from 'react';
import PropTypes from 'prop-types';
// import Script from 'react-load-script';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { withFetch } from 'shared/hocs/withFetch';
import { getToken } from 'shared/selectors/user';

import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Loader from '../Loader/Loader';
import s from './FondyContainer.css';
import closeUrl from '../../../mobile/components/Modal/cross.svg';

class FondyContainer extends React.Component {
  static propTypes = {
    frameUrl: PropTypes.node.isRequired,
    title: PropTypes.string,
    closeHandler: PropTypes.func.isRequired,
    callback: PropTypes.func,
    importantStyles: PropTypes.object, // eslint-disable-line
    //
    token: PropTypes.string.isRequired,
    fetch: PropTypes.func.isRequired,
  };
  static defaultProps = {
    isOpen: true,
    callback: null,
    title: 'PaymentFrame',
    importantStyles: {
      '.pages-checkout .page-section-shopinfo': {
        display: 'none',
      },
    },
  };
  state = {
    isFrameLoading: true,
  };
  componentDidMount() {
    this.handleFrameLoad();
  }
  handleCallback = function callback(data, type, self) {
    let form;
    if (data.error) {
      console.info(type);
      return;
    }
    if (data.action === 'redirect') {
      this.loadUrl(data.url);
      return;
    }
    if (data.send_data && data.send_data.order_status === 'delayed') {
      this.unbind('ready');
      this.hide();
    } else {
      this.unbind('ready').action('ready', function f() {
        this.show();
      });
    }
    if (data.send_data && data.url) {
      if (typeof self.props.callback === 'function') {
        self.props
          .fetch(data.url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `JWT ${self.props.token}`,
            },
            body: JSON.stringify({ ...data.send_data, noredirect: 1 }),
          })
          .then(r => r.json())
          .then(self.props.callback);
      } else {
        form = window.prepareFormData(data.url, data.send_data);
        this.find('body').appendChild(form);
        form.submit();
        form.parentNode.removeChild(form);
      }

      // action: "submit"
      // checkout_js_data: "{\"token\":\"663d9bd692d7597ce772f6c83fda4f16122336e4\",\"frame\":true}"
      // final: true
      // method: "POST"
      // send_data: {rrn: '021523241340', masked_card: '535838XXXXXX6000', sender_cell_phone: '', sender_account: '', currency: 'UAH', …}
      // target: "_top"
      // token: "663d9bd692d7597ce772f6c83fda4f16122336e4"
      // url: "http://localhost:3000/fondy/handle/?redirectUrl="
      // [[Prototype]]: Object
    }
  };
  handleFrameLoad = () => {
    const formUrl = this.props.frameUrl;
    const self = this;
    const element = document.getElementById('fondyChekout');
    let retry = 0;
    if (typeof window.$ipsp !== 'undefined' && element !== 'undefined' && element != null) {
      window.fCheckout = window.$ipsp
        .get('checkout')
        .config({ wrapper: element, styles: this.props.importantStyles })
        .scope(function f2() {
          this.setCheckoutWrapper(element);
          this.addCallback((data, type) => {
            self.handleCallback.call(this, data, type, self);
          });
          this.setModal(false);
          this.action('show', () => {
            self.setState({ isFrameLoading: false });
          });
          this.loadUrl(formUrl);
        });
    } else {
      // Little feature to preevent long loading in mobile
      retry += 1;
      if (retry === 20) {
        self.setState({ isFrameLoading: false });
      }
      setTimeout(() => {
        this.handleFrameLoad();
      }, 100);
    }
  };

  render() {
    const { title, closeHandler } = this.props;
    const { isFrameLoading } = this.state;
    return (
      <div className={s.Froot}>
        <div className={s.Fbg} onClick={closeHandler} />
        <div className={s.Fcontainer}>
          <button className={s.Fclose} onClick={closeHandler}>
            <img alt="" src={closeUrl} width="15" />
          </button>
          <div className={s.Fframe} title={title} id={'fondyChekout'} />
          <Loader isLoading={isFrameLoading} className={s.loader}>
            <button className={s.Fbutton} onClick={closeHandler}>
              <FormattedMessage id="Отменить" />
            </button>
          </Loader>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  token: getToken(state),
});

export default withStyles(s)(connect(mapStateToProps)(withFetch(FondyContainer)));



// WEBPACK FOOTER //
// ./src/shared/components/FondyFrame/FondyContainer.js